import authHeader from 'srcReact/helpers/auth-header'
import axios from 'axios'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const groupHomeService = {
  getGroupInfo,
  getGroupScope,
  getGroupWidgetScope,
  memberPendingApprove,
  memberPendingReject,
  suggestedAcceptMixr,
  suggestedRejectMixr,
  removeMemberFromGroup,
  deleteGroup,
  getMedia,
  getParticipants,
  deleteFileFromGroup,
  addStaffRole,
  removeStaffRole,
  removeFromGroup,
  getUsersToInvite
}

let cancel

function getGroupInfo(group_id, scope, widget_scope) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      group_id,
      scope,
      widget_scope
    }
  }
  return doRequestAxios(`/v2/group/information`, requestOptions)
}

function getGroupScope(group_id, scope, offset, quantity) {
  let params = { group_id, scope }
  switch (scope) {
    case 'future_mixrs':
      params = { ...params, future_mixrs_offset: offset, future_mixrs_quantity: quantity }
      break
    case 'past_mixrs':
      params = { ...params, scope, past_mixrs_offset: offset, past_mixrs_quantity: quantity }
      break
    default:
      params = { ...params }
      break
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: params
  }
  return doRequestAxios(`/v2/group/information`, requestOptions)
}

function getGroupWidgetScope(group_id, widget_scope) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      group_id,
      widget_scope
    }
  }
  return doRequestAxios(`/v2/group/information`, requestOptions)
}

function getUsersToInvite(group_id, scope, offset, quantity, search = '', order = '') {
  if (cancel) {
    cancel()
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      group_id,
      scope,
      suggested_members_offset: offset,
      suggested_members_quantity: quantity,
      suggested_members_search: search,
      suggested_members_order: order
    },
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }
  return doRequestAxios(`/v2/group/information`, requestOptions)
}

function suggestedAcceptMixr(mixr_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { mixr_id }
  }
  return doRequestAxios(`/v2/mixr/suggested/accept`, requestOptions)
}

function suggestedRejectMixr(mixr_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { mixr_id }
  }
  return doRequestAxios(`/v2/mixr/suggested/refuse`, requestOptions)
}

function memberPendingApprove(group_id, user_id) {
  const payload = {
    group_id,
    user_id
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/group/member/pending/approve`, requestOptions)
}

function memberPendingReject(group_id, user_id) {
  const payload = {
    group_id,
    user_id
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/group/member/pending/reject`, requestOptions)
}

function removeMemberFromGroup(group_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: {
      group_id
    }
  }

  return doRequestAxios(`/v2/group/member/remove`, requestOptions)
}

function deleteGroup(group_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: {
      group_id
    }
  }
  return doRequestAxios(`/v2/group/edition/delete`, requestOptions)
}

function getMedia(id, type = 'pictures_media', offset, quantity, search, filter) {
  let params = ''
  if (type === 'pictures_media') {
    params += `&pictures_media_offset=${offset}`
    params += `&pictures_media_quantity=${quantity}`
  } else if (type === 'shared_links') {
    params += search.length > 0 ? `&shared_links_search=${search}` : ''
    params += `&shared_links_offset=${offset}`
    params += `&shared_links_quantity=${quantity}`
  } else if (type === 'documents_media') {
    params += search.length > 0 ? `&documents_media_search=${search}` : ''
    params += `&documents_media_filter=${filter}`
    params += `&documents_media_offset=${offset}`
    params += `&documents_media_quantity=${quantity}`
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return doRequestAxios(`/v2/group/information?group_id=${id}${params}&scope=${type}`, requestOptions)
}

function getParticipants(eventId, scope, offset, quantity, search, order) {
  if (cancel) {
    cancel()
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }
  let params = scope && scope.length > 0 ? `&scope=${scope}` : ''
  if (scope === 'active_members') {
    params += search.length > 0 ? `&active_members_search=${search}` : ''
    params += order ? `&active_members_order=${order}` : ''
    params += offset ? `&active_members_offset=${offset}` : ''
    params += quantity ? `&active_members_quantity=${quantity}` : ''
  } else {
    params += search.length > 0 ? `&staff_members_search  =${search}` : ''
    // params += `&participants_order=${order}`
    params += offset ? `&staff_members_offset=${offset}` : ''
    params += quantity ? `&staff_members_quantity=${quantity}` : ''
  }
  return doRequestAxios(`/v2/group/information?group_id=${eventId}${params}`, requestOptions)
}

function deleteFileFromGroup(groupId, fileId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: null
  }
  return doRequestAxios(`/v2/group/file/remove?group_id=${groupId}&file_id=${fileId}`, requestOptions)
}

function addStaffRole(groupId, userId, role) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: null
  }
  return doRequestAxios(`/v2/group/staff/role/add?group_id=${groupId}&user_id=${userId}&role=${role}`, requestOptions)
}

function removeStaffRole(groupId, userId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: null
  }
  return doRequestAxios(`/v2/group/staff/role/remove?group_id=${groupId}&user_id=${userId}`, requestOptions)
}

function removeFromGroup(groupId, userId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: null
  }
  return doRequestAxios(`/v2/group/member/remove?group_id=${groupId}&user_id=${userId}`, requestOptions)
}
